export default __webpack_public_path__ + "static/media/stewardship-matters-logo.f3439890.png";